import * as React from 'react';
import { Button } from './Button';
import { withTheme } from 'styled-components';

interface Props {
  click?: (e?) => void;
  style?: React.CSSProperties;
  color?: string;
  onClick?: (e?: any) => void;
  roundOnMobile?: boolean;
  widthOnMobile?: string;
  type?: string;
  theme?: any;
}
class ButtonPrimary extends React.Component<Props> {
  render() {
    const { children, click, color, type, theme } = this.props;

    return (
      <Button
        type={type}
        roundOnMobile={this.props.roundOnMobile}
        width="100%"
        height="40px"
        color={color ? color : theme.btnPrimary}
        radius="6px"
        fontSize="16px"
        click={click}
        style={this.props.style}
        widthOnMobile={this.props.widthOnMobile}
      >
        {children}
      </Button>
    );
  }
}
export default withTheme(ButtonPrimary);
